import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep2 = (props) => {


    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight2}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                </div>
                <div className={css.content}>
                    <i class="fi fi-rr-cross-small"></i>
                    <div className={css.title}>👤 Explore Your Profile Details! </div>
                    <div className={css.desc}>The 'Profile Details' section showcases information such as owner name, plant type, total string capacity, and plant address. Click here to access and manage your energy profile effortlessly. Let's dive into your energy data!</div>
                    <div className={css.step}>2/10</div>
                    <NavLink to="/plant-management" onClick={props.prev}>
                        <button className={css.prev}>Previous</button>
                    </NavLink>
                    <NavLink to="/home" onClick={props.next}>
                        <button className={css.next}>Next</button>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep2;
